import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '@/config/firebase';

export const PRIVATE_FIELDS = new Set([
  'email', 'phone', 'apartment', 'building', 'identifier',
  'residentId', 'photoURL', 'landlordType', 'landlordId',
  'notificationPrefs', 'chatEnabled', 'requestsEnabled',
  'rejectionReason', 'invitedById', 'joinedAt', 'createdAt', 'updatedAt',
]);

export function splitMemberData(data: Record<string, any>): {
  publicData: Record<string, any>;
  privateData: Record<string, any>;
} {
  const publicData: Record<string, any> = {};
  const privateData: Record<string, any> = {};
  for (const [key, value] of Object.entries(data)) {
    if (PRIVATE_FIELDS.has(key)) {
      privateData[key] = value;
    } else {
      publicData[key] = value;
    }
  }
  return { publicData, privateData };
}

export async function batchFetchMemberPrivate(
  uids: string[]
): Promise<Record<string, Record<string, any>>> {
  if (uids.length === 0) return {};
  const results = await Promise.allSettled(
    uids.map(uid => getDoc(doc(db, 'memberPrivate', uid)))
  );
  const result: Record<string, Record<string, any>> = {};
  results.forEach((settled, i) => {
    if (settled.status === 'fulfilled') {
      if (settled.value.exists()) result[uids[i]] = settled.value.data();
    } else {
      console.warn('[memberPrivate] getDoc failed for', uids[i], settled.reason);
    }
  });
  return result;
}

export async function writeMemberPrivate(
  uid: string,
  data: Record<string, any>,
  merge = true
): Promise<void> {
  const ref = doc(db, 'memberPrivate', uid);
  if (merge) {
    await setDoc(ref, data, { merge: true });
  } else {
    await setDoc(ref, data);
  }
}

export async function updateMemberPrivate(
  uid: string,
  data: Record<string, any>
): Promise<void> {
  await updateDoc(doc(db, 'memberPrivate', uid), data);
}
